import React, { Component } from 'react'
import classNames from 'classnames'
import { AppTopbar } from '../AppTopbar'
import { AppFooter } from '../AppFooter'
import { AppMenu } from '../AppMenu'
import { AppProfile } from '../AppProfile'
import { SidebarBottom } from '../SidebarBottom'
import { GLOBALS } from '../../utils/Globals'
import { Context } from '../../Context'
export class Layout extends Component {
  static contextType = Context

  constructor() {
    super()
    this.state = {
      layoutMode: 'static',
      layoutColorMode: 'dark',
      staticMenuInactive: false,
      overlayMenuActive: false,
      mobileMenuActive: false,
      userLogged: null,
      isUserLoggedStudent: false,
    }

    this.onWrapperClick = this.onWrapperClick.bind(this)
    this.onToggleMenu = this.onToggleMenu.bind(this)
    this.onSidebarClick = this.onSidebarClick.bind(this)
    this.onMenuItemClick = this.onMenuItemClick.bind(this)
    this.createMenu()
  }

  onWrapperClick(event) {
    if (!this.menuClick) {
      this.setState({
        overlayMenuActive: false,
        mobileMenuActive: false,
      })
    }

    this.menuClick = false
  }

  onToggleMenu(event) {
    this.menuClick = true

    if (this.isDesktop()) {
      if (this.state.layoutMode === 'overlay') {
        this.setState({
          overlayMenuActive: !this.state.overlayMenuActive,
        })
      } else if (this.state.layoutMode === 'static') {
        this.setState({
          staticMenuInactive: !this.state.staticMenuInactive,
        })
      }
    } else {
      const mobileMenuActive = this.state.mobileMenuActive
      this.setState({
        mobileMenuActive: !mobileMenuActive,
      })
    }

    event.preventDefault()
  }

  onSidebarClick(event) {
    this.menuClick = true
  }

  onMenuItemClick(event) {
    if (!event.item.items) {
      this.setState({
        overlayMenuActive: false,
        mobileMenuActive: false,
      })
    }
  }

  addClass(element, className) {
    if (element.classList) element.classList.add(className)
    else element.className += ' ' + className
  }

  removeClass(element, className) {
    if (element.classList) element.classList.remove(className)
    else
      element.className = element.className.replace(
        new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'),
        ' '
      )
  }

  isDesktop() {
    return window.innerWidth > 1024
  }

  componentDidMount() {
    // const isStudent = this.context.userLogged.role === GLOBALS.roles.student.id

    const isMenuVisible = this.props.isMenuVisible !== undefined ? this.props.isMenuVisible : true

    this.setState({
      staticMenuInactive: !isMenuVisible,
    })

    this.setState({
      userLogged: this.context.userLogged,
    })
  }

  componentDidUpdate() {
    if (this.state.mobileMenuActive) this.addClass(document.body, 'body-overflow-hidden')
    else this.removeClass(document.body, 'body-overflow-hidden')
  }

  createMenu() {
    this.menuC = [
      {
        label: GLOBALS.menu.dashboard.title,
        icon: GLOBALS.menu.dashboard.icon,
        to: GLOBALS.menu.dashboard.link,
      },
      /*         {
            label: GLOBALS.menu.programs.title,
            icon: GLOBALS.menu.programs.icon,
            to: GLOBALS.menu.programs.linkList,
        }, */
      {
        label: GLOBALS.menu.courses.title,
        icon: GLOBALS.menu.courses.icon,
        to: GLOBALS.menu.courses.linkList,
      },
      {
        label: GLOBALS.menu.laboratories.title,
        icon: GLOBALS.menu.laboratories.icon,
        to: GLOBALS.menu.laboratories.linkList,
      },
      {
        label: GLOBALS.menu.pods.title,
        icon: GLOBALS.menu.pods.icon,
        to: GLOBALS.menu.pods.linkList,
      },
      {
        label: GLOBALS.menu.remoteresource.title,
        icon: GLOBALS.menu.remoteresource.icon,
        to: GLOBALS.menu.remoteresource.linkList,
      },
    ]

    this.menuT = [
      {
        label: GLOBALS.menu.dashboard.title,
        icon: GLOBALS.menu.dashboard.icon,
        to: GLOBALS.menu.dashboard.link,
      },
      {
        label: GLOBALS.menu.courses.title,
        icon: GLOBALS.menu.courses.icon,
        to: GLOBALS.menu.courses.linkList,
      },
      {
        label: GLOBALS.menu.reserve.title,
        icon: GLOBALS.menu.reserve.icon,
        to: GLOBALS.menu.reserve.linkList,
      },
    ]

    this.menuU = [
      {
        label: GLOBALS.menu.dashboard.title,
        icon: GLOBALS.menu.dashboard.icon,
        to: GLOBALS.menu.dashboard.link,
      },
      {
        label: GLOBALS.menu.courses.title,
        icon: GLOBALS.menu.courses.icon,
        to: GLOBALS.menu.courses.linkList,
      },
      {
        label: GLOBALS.menu.reserve.title,
        icon: GLOBALS.menu.reserve.icon,
        to: GLOBALS.menu.reserve.linkList,
      },
    ]

    this.menuS = [
      {
        label: GLOBALS.menu.dashboard.title,
        icon: GLOBALS.menu.dashboard.icon,
        to: GLOBALS.menu.dashboard.link,
      },
      {
        label: GLOBALS.menu.users.title,
        icon: GLOBALS.menu.users.icon,
        to: GLOBALS.menu.users.linkList,
      },
      /*             {
                label: GLOBALS.menu.programs.title,
                icon: GLOBALS.menu.programs.icon,
                to: GLOBALS.menu.programs.linkList,
            }, */
      {
        label: GLOBALS.menu.courses.title,
        icon: GLOBALS.menu.courses.icon,
        to: GLOBALS.menu.courses.linkList,
      },
      {
        label: GLOBALS.menu.laboratories.title,
        icon: GLOBALS.menu.laboratories.icon,
        to: GLOBALS.menu.laboratories.linkList,
      },
      {
        label: GLOBALS.menu.pods.title,
        icon: GLOBALS.menu.pods.icon,
        to: GLOBALS.menu.pods.linkList,
      },
      {
        label: GLOBALS.menu.remoteresource.title,
        icon: GLOBALS.menu.remoteresource.icon,
        to: GLOBALS.menu.remoteresource.linkList,
      },
    ]
  }

  render() {
    const rolobject = this.context.userLogged
    const roleuser = rolobject.role
    let configMenu = ''
    if (roleuser === 'S') {
      configMenu = this.menuS
    } else if (roleuser === 'T') {
      configMenu = this.menuT
    } else if (roleuser === 'U') {
      configMenu = this.menuU
    } else if (roleuser === 'C') {
      configMenu = this.menuC
    }

    const logo =
      this.state.layoutColorMode === 'dark'
        ? '/assets/layout/images/logo-white.png'
        : '/assets/layout/images/logo-whitse.png'

    const wrapperClass = classNames('layout-wrapper', {
      'layout-overlay': this.state.layoutMode === 'overlay',
      'layout-static': this.state.layoutMode === 'static',
      'layout-static-sidebar-inactive':
        this.state.staticMenuInactive && this.state.layoutMode === 'static',
      'layout-overlay-sidebar-active':
        this.state.overlayMenuActive && this.state.layoutMode === 'overlay',
      'layout-mobile-sidebar-active': this.state.mobileMenuActive,
    })

    const sidebarClassName = classNames('layout-sidebar', {
      'layout-sidebar-dark': this.state.layoutColorMode === 'dark',
      'layout-sidebar-light': this.state.layoutColorMode === 'light',
    })

    return (
      <div className={wrapperClass} onClick={this.onWrapperClick}>
        <AppTopbar showToggler={!this.state.isUserLoggedStudent} onToggleMenu={this.onToggleMenu} />
        {!this.state.isUserLoggedStudent ? (
          <div
            ref={(el) => (this.sidebar = el)}
            className={sidebarClassName}
            onClick={this.onSidebarClick}
          >
            <div className="sidebar-content">
              <div className="layout-logo">
                <img alt="Logo" src={logo} width="150" />
              </div>
              <AppProfile />
              <AppMenu model={configMenu} onMenuItemClick={this.onMenuItemClick} />
            </div>
            <SidebarBottom />
          </div>
        ) : (
          <div />
        )}
        <div className="layout-main"> {this.props.children} </div>
        <AppFooter />
        <div className="layout-mask"> </div>{' '}
      </div>
    )
  }
}
